import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import selectIsModalOpened from '../../../core/selectors/modal';
import { closeModal } from '../../../core/actions/modal';
import { localeSelector } from '../../../core/selectors/i18n';
import { DONE_MODAL } from '../../constants/modal';

const DoneModal = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => selectIsModalOpened(state, DONE_MODAL));
    const lng = useSelector(localeSelector);
    const onClose = () => {
        dispatch(closeModal(DONE_MODAL));
        navigate('/sell');
    };
    const navigate = useNavigate();
    return (
        <Modal show={isOpen} onHide={onClose} className="modal show modal-fullscreen-sm-down" style={{ display: 'block' }}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="done-publish__container text-center">
                    <div className="done-publish__image rounded-4">
                        <span></span>
                    </div>
                    <div className="done-publish__title text-primary h2 fw-bold">
                        <FormattedMessage id='sell_we_are_done'/>
                    </div>
                    <div className="other-provider__text mb-3">
                        <FormattedMessage id='sell_we_have_successfully_posted_your_listing'/>
                    </div>
                    <div className="d-inline-grid gap-3">
                        <a href="/" className={'btn btn-outline-primary'}><FormattedMessage id="back_to_homepage"/></a>
                        <a href={`/${lng}/profile/sales`} className={'btn btn-primary'}><FormattedMessage id="see_your_listings"/></a>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};
export default DoneModal;
